import React from 'react'
import ReactDOM from 'react-dom/client'
import App from '@/App.jsx'
import '@/index.css'

if (import.meta.env.PROD) {
    // Shim זמני כדי למנוע קריסה אם יש קובץ שמשתמש ב-useState בלי ייבוא
    // ⚠️ להסיר אחרי שמאתרים ומתקנים את הקובץ הבעייתי
    window.React = React;
    window.useState = React.useState;
    window.useEffect = React.useEffect;
    window.useMemo = React.useMemo;
    window.useRef = React.useRef;
  }
ReactDOM.createRoot(document.getElementById('root')).render(
    <App />
) 